import { render, staticRenderFns } from "./CaseCustomVariables.vue?vue&type=template&id=0b489227&"
import script from "./CaseCustomVariables.vue?vue&type=script&lang=js&"
export * from "./CaseCustomVariables.vue?vue&type=script&lang=js&"
import style0 from "./CaseCustomVariables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports